.spinner {
  display: inline-block;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-right-color: transparent;
  opacity: 0.9;
  animation: spin 700ms linear infinite;
}

.sm {
  width: 16px;
  height: 16px;
}

.md {
  width: 24px;
  height: 24px;
}

.lg {
  width: 40px;
  height: 40px;
  border-width: 3px;
}

.wrapper {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.accent {
  color: var(--color-interactive);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation-duration: 2400ms;
  }
}
